import 'shepherd.js/dist/css/shepherd.css';

import '@/i18n'

import { Crisp } from "crisp-sdk-web";
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App as NativeApp } from '@capacitor/app';
import { Capacitor } from "@capacitor/core";
import { TextZoom } from "@capacitor/text-zoom";

import '@capacitor-community/safe-area';

import './index.css'
import App from './App.tsx'

import { init as Sentry } from '@sentry/react';
import mixpanel from "mixpanel-browser";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
const CRISP_ID = import.meta.env.VITE_CRISP_ID
const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN

if (SENTRY_DSN) {
  Sentry({ dsn: SENTRY_DSN, integrations: [] })
}

if (CRISP_ID) {
  Crisp.configure(CRISP_ID)
}

if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: false,
    autocapture: true,
    track_pageview: true,
    persistence: "localStorage",
  });
}

/* Native Configurations */
if (Capacitor.isNativePlatform()) {
  TextZoom.getPreferred().then((prefference) => {
    const { value } = prefference

    if (value < 1) { TextZoom.set({ value: 1 }); }
  });

  NativeApp.addListener('backButton', () => {
    window.history.back()
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
